module.exports = __webpack_public_path__ + "school/img/jiao.2995a63b.jpg";